export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    getById (context, payload) {
      const promise = this.server.chapterById(payload)
      return promise
    },
    getChapters (context, payload) {
      console.log(payload)
      const promise = this.server.chapterList(payload)
      return promise
    },
    add (context, payload) {
      const promise = this.server.addChapter(payload)
      return promise
    },
    update (context, payload) {
      const promise = this.server.updateChapter(payload)
      return promise
    },
    remove (context, payload) {
      const promise = this.server.deleteChapter(payload)
      return promise
    }
  }
}
